import styled from "styled-components";
import { SubmitButton } from "../../register/styled/global-styled";

export const LoginButton = styled(SubmitButton)`
  background: ${(props) => (props.active ? "#6E7FA0" : "#8A98B3")};
`;
